<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

const props = withDefaults(
  defineProps<{
    id?: string | null
    text?: string | null
  }>(),
  { id: null, text: null }
)

const emit = defineEmits<{
  (e: 'closed'): void
  (e: 'confirmDeletion', id: string): void
}>()

function close (): void {
  model.value = false
}

function closed () {
  emit('closed')
}

function confirmDeletion (): void {
  emit('confirmDeletion', props.id!)

  close()
}
</script>

<template>
  <CustomModalWindow v-model="model" @closed="closed">
    <template #title>
      {{ text }}
    </template>

    <div class="flex space-x-2">
      <BasicButton color="body-background" title="Нет, оставить" @click="close" />
      <BasicButton color="red" title="Да, удалить" @click="confirmDeletion" />
    </div>
  </CustomModalWindow>
</template>
